<template>
  <pre_input :value="model && item_text_fun(model,item_text)" :label="label" :md="md" :tag="c_tag" :view_only="view_only" >
    <fs1-span><b>{{label || ''}}</b></fs1-span>
    <slot></slot>
    <v-combobox
      v-if="edit_m"
      :class="[(model || search) || disabled? '': 'textEmpty', disabled?'valueContainer in_rq_disabled':'']"
      v-model="model"
      :search-input.sync="search"
      :prepend-icon="p_icon"
      :append-icon="a_icon"
      :item-text="item_text"
      :item-value="item_value"
      :disabled="disabled"
      :hide-details="!!condensed || disabled"
      :clearable="!!items.length"
      @change="(event)=>change_m(null,'change',event)"
      @blur="(event)=> (edit_m =false) ||change_m(null,'blur',event)"
      @click:clear="(e)=>change_m(null,'clear')"
      :placeholder="disabled?'':c_placeholder"
      :items="items"
      :md="md || 4"
      no-filter>
        <template v-slot:item={item}>
          <div>{{item_text_fun(item,item_text)}}</div>
        </template>
        <template v-slot:selection={item}>
        <v-chip small close @click:close="remove(item)" v-if="item_text_fun(item,item_text)">
          {{item_text_fun(item,item_text)}}
        </v-chip>
        </template>
        <template v-slot:append-item>
          <div v-intersect="endIntersect"></div>
        </template>
    </v-combobox>

    <v-combobox
      v-else
      :class="[(model || search) || disabled? '': 'textEmpty', disabled?'valueContainer in_rq_disabled':'']"
      v-model="model" 
      :prepend-icon="p_icon"
      :append-icon="a_icon"
      :item-text="item_text"
      :item-value="item_value"
      @keypress="(e)=> e.preventDefault()"
      :hide-details="!!condensed || disabled"
      :clearable="!!items.length"
      @focus="()=> edit_m = true"      
      @click:clear="(e)=>change_m(null,'clear')"
      :placeholder="disabled?'':c_placeholder"
      :items="items"
      :md="md || 4"
      no-filter>
        <template v-slot:selection={item}>
          <v-chip small close @click:close="remove(item)" v-if="item_text_fun(item,item_text)">
            {{item_text_fun(item,item_text)}}
          </v-chip>
        </template>
    </v-combobox>
    <!--  este componenete(v-combobox) funciona con detalles en esta configuracion, especificando item-value model deberia ser un id pero retorna objeto-->
  </pre_input>
</template>

<script>
import pre_input_js from '@/components/mixins/pre_input';
import Debounce from '@/components/Debounce';

export default {
  props:{
    p_icon:{},
    searched:{},
    value:{},
    item_text_fun:{default:()=>{return (t,n)=>t[n] }},
    item_text:{default:'name'},
    item_value:{default:'id'},
    obj_val:{default:()=>{return {}}},
    k_f:{default:`s__name`},
    get_name:{/* default:'critical_asset' */},
    value_not_found:{default:false},//boleano que pasa a true si no se encuentra
    search_not_found:{default:false},//boleano que pasa a true si no se encuentra
    search_ex_filter:{},
  },
  mixins: [ Debounce, pre_input_js  ],
  data(){
    return {
      edit_m:false,
      search:null,
      model: null,/* es un objeto */
      items: [],
      is_intersecting:false,
      has_next_page:false,
      count:0,
      page:1,
      getting:false,
    }
  },
  watch: {
    'search'(v,v_old){
      this.has_next_page = false;
      this.count = 0;
      this.page = 1;
      this.$emit('update:searched', v);
      this.dev_log(7,{v,v_old});
      if (v) this.debounceM('search', ()=>this.set_model(v,v_old));
      else {
        
          /* this.$emit('update:obj_val', {});
          this.items = []; */
        
      }
      /* else this.set_model() */
    },
    'value'(v,v_old){ 
      if (v === v_old) return;
      if ((this.model && this.model[this.item_value]) != this.value) {
        this.dev_log(6);
        this.set_model()
      }
    },
    'is_intersecting'(o,v){
      if(this.is_intersecting) this.infiniteScroll();
    }
  },
  created(){
    this.set_model();
  },
  methods: {
    remove(item) { this.model && this.model.splice?this.model.splice(this.model.indexOf(item), 1):(this.model = null) },
    /* se usa cuando se selecciona uno de la lista, se busca y es lo unico retornado, se limpia */
    change_m(val,ev,event){
      if (ev == 'blur') {
        this.search = '';
        return;
      }
      this.dev_log(8,{val,ev},this.model,(this.model||{})[this.item_value]);
      this.$emit('update:value', (this.model||{})[this.item_value] || null);
      this.$emit('update:obj_val', typeof this.model == 'object' && this.model !== null? this.model: {});
    },
    set_model() {
/* this.value && this.value != this.model && this.search */
        /* formulario vacio */
        if (this.value === null && !this.model && !this.search) {
          this.dev_log(1,this.search);
          this.items = [];
          return;
        }
        /* no se a buscado escribiendo pero hay valor, entonces es pq se abrio un formulario con datos */
        if (!this.search && this.value) {
          this.dev_log(2);
          const filter = this.search_ex_filter? {...this.search_ex_filter}:{};
          filter[this.item_value] = this.value;
          this.requests.getsSimple[`${this.get_name}/a/all`](filter)
            .then(r => {
              if (r.results && r.results[0]) {
                this.has_next_page = !!r.next;
                //this.search = r.results[0][this.item_text];
                this.model = r.results[0];
                if (this.obj_val) this.$emit('update:obj_val', r.results[0]);
              }
              else if (this.value_not_found === false) this.$emit('update:value_not_found', true);
            })          
          return;
        }
        /* busqueda normal tras escribir en el input */
        if (this.search) {
          this.dev_log(3);
          const filter = this.search_ex_filter? {...this.search_ex_filter}:{};
          filter[this.k_f] = this.search;
          /* page size? */
          this.requests.getsSimple[`${this.get_name}/a/all`](filter)
            .then(r => {
              this.has_next_page = !!r.next;
              this.items = r.results;
              if (r.count === 0) this.$emit('update:search_not_found', true);
              if (this.items.length === 1) {
                this.dev_log(9,this.model);
                const search = this.items[0][this.item_text];
                if (search != this.search) this.search = search;
              }
            })
        }
        /* se vacio*/
        else {
          this.dev_log(4);
          this.model = null;
          this.items = [];
          this.change_m(null);
        }
    },

    endIntersect(entries, observer, isIntersecting) {
      //console.log({entries, observer, isIntersecting});
      this.is_intersecting = isIntersecting;
    },
    infiniteScroll() {
      //console.log(this.has_next_page ,this.getting);
      if(this.has_next_page && !this.getting) {
        //console.log('---->',this.m_search);
        this.getting = true;
        this.page++;

        const filters = this.search_ex_filter? {...this.search_ex_filter}:{};
        filters[this.k_f] = this.search;
        filters.page = this.page;
  
        this.requests.getsSimple[`${this.get_name}/a/all`](filters)
          .then(r => {
            this.has_next_page = !!r.next;
            if (this.has_next_page === false) this.page--;
            this.count = r.count;
            this.items = this.items.concat(r.results);
            this.getting = false;;
          })
          .catch(e=>{
            this.getError(e);
            this.getting = false;
          })
      }
    },
  },
};
</script>
